import Highcharts from 'highcharts';
import 'highcharts/highcharts-more';

window.Highcharts = Highcharts;
